var _defs, _path, _path2, _rect, _text, _path3, _path4, _rect2, _text2, _path5, _path6, _path7, _i, _br, _text3, _path8, _path9, _rect3, _text4, _path10, _path11, _path12, _path13, _path14, _i2, _br2, _text5, _path15, _path16, _rect4, _text6, _path17, _path18, _path19, _path20, _rect5, _br3, _text7, _rect6, _text8, _rect7, _text9, _rect8, _text10, _rect9, _text11, _rect10, _text12, _switch;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlowChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "264px",
    height: "489px",
    viewBox: "0 0 352 652",
    content: "7Vptc+I2EP41zLQfuPELOOQjEC5tL71JS65pPiq2sNXIFifJgO/XV8KSX7B5CTGYtJlhBmslr6R99tldy+7Y43B1S8E8+J14EHcsw1t17JuOZQ0sqyN/hpekAmcwSAU+RV4qMnPBFP2ASmgoaYw8yEoDOSGYo3lZ6JIogi4vyQClZFkeNiO4POsc+LAimLoAV6WPyONBKrUGRi7/BSI/UDP3LdURAj1WCVgAPLIsiOxJxx5TQnh6Fa7GEEvTabM8/po84rsX5/a3P9h38G305eHrX91U2efX3JLtgMKIH60aodHVYMa+mY+D5zF1lybAi66CkvFEmwt6wnqqSSgPiE8igCe5dERJHHlQajVEKx9zR8hcCE0h/AdynihXADEnQhTwEKtesQua/C3v/9TXzSelbt24WZVaiWqla5UL3EB2j13UOEZi6sIdxlA4c0B9yHeMMzPwBWcgCaFYpLiPQgw4WpQXB5T3+tm4HCJxoVB6BWJqkQuAYzVTx3KwWO5oRoQVilg632OiO7psjcZQDDB781XeKa58+T8V2+ZalVhZqi3tqzhJ7gISz2WAOJzOwdq4SxFEynAD6ipX6OcoLiDlcHUEjlW7Ky2apsuc5JrjQYHfPeNEwFy3QqUV4gUmidZToSfnkWwkRVJdIP10cthHP6tN+plb6eehxfHsa4bDf8aR6BvGfigQEW5lGTfIfYFJ93OMMaSi/QDZdpJn4vVW9lLf2E/9xrmelIld4LppnZPsurj5YPuxbLcOZLvdJtutEyXbeTdVKX3WAaFkjeKeYXwy+nqSZ1pDzt2JOSDhc8zaY6bZP5CazsmoaX3UtBv0OYBmvTZpZl9+Uv1yP50elz+bWEMWJaJnJv9+uoMLiH9+fbneYs7OknF7Sdu+pMhgthwZegdGBqfVctu5JMjaDuaHQmb228Ss10bRZL7jmsk2W6+Zrt5MM5eEyD2ecqemzlujmLr1nqC1C6/KgCT1+KREVffkEA0pBUlh2FwOYNtnyY62ytPkgKcKc/izDR7vEc7ukqzJ4uYGzWZQwOyiyD+qtmp8RQ8olGFmCimC7D0fl2gtG36atVsrxa5q3GszAEXeUL7+ES0XA8ZkdKk7DNHXT53iwci+w5BSWs+z/JbELjYNJh7iNbGOCTSF4z6s49wlHZxsiXgFyPs1iGvZGwPjddnh7E1HSndZiYwVPWavrChTvCfENhUG9c7bS4zH1qIyVimlZu8MbpnWnIcc3xv1jnmmB4r+7sR2CWcNtxRE/vq4fgxiBjDi0j5Idt0DRNkrSt13kKMSnWrazknmoOIaT5BVrCX2zcsmYZySFzgmmFAhiUgkg8AMYbwhEkj6kUxn8u2MkI+kFZEL8FB1hMjz1hGkDoMySvX0br50sDfibw1K9llBuv4AaR9Idk15d1aQNG0bPwKYRN5/4RMFHfJqXmOe9ZMFXXUXcPpK/udcMq39z0q9GpCsk4FUfTvyAdIGSHbNxz8NgSSa+Sd+6WNF/pmkPfkX",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 75 50 L 75 92.04",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 75 98.6 L 70.63 89.85 L 75 92.04 L 79.38 89.85 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 0,
    width: 100,
    height: 50,
    rx: 25,
    ry: 25,
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 1.25,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(1.25)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 20,
      marginLeft: 21
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Start"))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 24,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Start")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 75 150 L 75 179.54",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 75 186.1 L 70.63 177.35 L 75 179.54 L 79.38 177.35 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 100,
    width: 150,
    height: 50,
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 1.25,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(1.25)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 100,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 14
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Run Augmented Dickey-Fuller Test")))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 104,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Run Augmented Dickey...")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 75 262.5 L 75 292.04",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 75 298.6 L 70.63 289.85 L 75 292.04 L 79.38 289.85 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 75 187.5 L 150 225 L 75 262.5 L 0 225 Z",
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(1.25)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 180,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Reject ", _i || (_i = /*#__PURE__*/React.createElement("i", null, "H", /*#__PURE__*/React.createElement("sub", null, "0"))), "?", _br || (_br = /*#__PURE__*/React.createElement("br", null))))))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 184,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "p-value &lt; 0.05&#xa;")))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 75 350 L 75 375 L 75 362.5 L 75 379.54",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 75 386.1 L 70.63 377.35 L 75 379.54 L 79.38 377.35 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 300,
    width: 150,
    height: 50,
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 1.25,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(1.25)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 260,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 14
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Run KPSS Test")), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "\xA0(Level)"))))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 264,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Run KPSS Test\xA0(Level)")))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 150 425 L 275 425 L 275 257.96",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 275 251.4 L 279.38 260.15 L 275 257.96 L 270.63 260.15 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 75 462.5 L 75 487.5 L 75 475 L 75 492.04",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 75 498.6 L 70.63 489.85 L 75 492.04 L 79.38 489.85 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 75 387.5 L 150 425 L 75 462.5 L 0 425 Z",
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(1.25)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 340,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Accept ", _i2 || (_i2 = /*#__PURE__*/React.createElement("i", null, "H", /*#__PURE__*/React.createElement("sub", null, "0"))), "?", _br2 || (_br2 = /*#__PURE__*/React.createElement("br", null))))))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 344,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Reject H0&#xa;")))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 275 200 L 275 75 L 82.96 75",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 76.4 75 L 85.15 70.63 L 82.96 75 L 85.15 79.38 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 200,
    width: 150,
    height: 50,
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 1.25,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(1.25)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 180,
      marginLeft: 161
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Differencing")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Time Series")))))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 184,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Differencing...")))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 150 225 L 192.04 225",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 198.6 225 L 189.85 229.38 L 192.04 225 L 189.85 220.63 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 75 550 L 75 592.04",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 75 598.6 L 70.63 589.85 L 75 592.04 L 79.38 589.85 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 500,
    width: 150,
    height: 50,
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 1.25,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(1.25)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 420,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 14
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "Run Granger Test in Pairs", _br3 || (_br3 = /*#__PURE__*/React.createElement("br", null)))))))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 424,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Run Granger Causalit...")))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 250,
    width: 37.5,
    height: 50,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(1.25)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 28,
      height: 1,
      paddingTop: 220,
      marginLeft: 31
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "Yes")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 224,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Yes")))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 450,
    width: 37.5,
    height: 50,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(1.25)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 28,
      height: 1,
      paddingTop: 380,
      marginLeft: 31
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "Yes")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 384,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Yes")))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 600,
    width: 100,
    height: 50,
    rx: 25,
    ry: 25,
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 1.25,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(1.25)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 500,
      marginLeft: 21
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    }
  }, "End"))))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 504,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "End")))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 200,
    width: 50,
    height: 25,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(1.25)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 170,
      marginLeft: 121
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "No")))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 174,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "No")))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 400,
    width: 50,
    height: 25,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(1.25)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 330,
      marginLeft: 121
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "No")))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 334,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "14px",
    textAnchor: "middle"
  }, "No"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Viewer does not support full SVG 1.1")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowChart);
export default __webpack_public_path__ + "static/media/FlowChart.27d0834e.svg";
export { ForwardRef as ReactComponent };